import { handwritten } from "./tokens";

// White-framed photo with a handwritten caption. Rotate via a wrapper
// (`rotate-2`/`-rotate-3` + `transform-gpu`) at the call site.
//
// The frame and the caption are both PINNED (see .polaroid-frame in
// styles.css). The caption was text-gray-600, which flips to a light grey in
// dark mode; on a frame that is white in both themes that is invisible.
export function Polaroid({
  src,
  caption,
  size = "md",
}: {
  src: string;
  caption: string;
  size?: "sm" | "md" | "lg";
}) {
  const dims =
    size === "sm"
      ? "w-32 h-40"
      : size === "lg"
        ? "w-full max-w-md aspect-[3/4]"
        : "w-full aspect-square";
  return (
    <div className={`polaroid-frame p-3 pb-10 shadow-xl ${dims}`}>
      <div className="w-full h-full overflow-hidden">
        <img
          src={src}
          alt={caption}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <p
        className="mt-2 text-center polaroid-caption"
        style={{ ...handwritten, fontSize: size === "sm" ? "14px" : "20px" }}
      >
        {caption}
      </p>
    </div>
  );
}
